/**
 * Static generation for Cloudflare Pages.
 * `prerender = true` snapshots HTML at build; `ssr = false` means
 * everything hydrates client-side.
 *
 * This is required for Level 0: there is no runtime server to leak
 * data, no edge function with access to user content, no logs to harvest.
 */

export const prerender = true;
export const ssr = false;
export const trailingSlash = 'never';
